// After more than NodeProvider option is added to this,
// we should re-enable the automatic switch mechanism, by using useCheckNodeProviderStatuses in AppContext,
// and the node provider settings tab on the settings modal, see settingsTabUtils.
export type AlgorandNodeProviderType = "algodev";

type AlgodCredentialShape = Record<
  AlgorandNodeProviderType,
  Readonly<{
    clientToken: string;
    clientServer: string;
    indexerToken: string;
    indexerServer: string;
    port: number;
  }>
>;

interface AlgorandNodeProvider {
  type: AlgorandNodeProviderType;
  isHealthy: boolean;
  title: string;
}

interface AlgodCredentials {
  mainnet: AlgodCredentialShape;
  testnet: AlgodCredentialShape;
}

const DEFAULT_ALGORAND_NODE_PROVIDER_TYPE: AlgorandNodeProviderType = "algodev";

const ALGOD_CREDENTIALS: AlgodCredentials = {
  mainnet: {
    algodev: {
      clientToken: "0dw4Qu6ckPJTQY540Z0sEokH910KUWKjsf312fxNtTcVjw5UUhhlK4s4odcXIoEz",
      clientServer: "https://node-mainnet.chain.perawallet.app/",
      indexerToken: "KegWFLYQnBNVeP4oHCX64dObBk8VemzYdNqsnAOIxYQ8aqJLQTYeVDQyZNnx1PZA",
      indexerServer: "https://indexer-mainnet.chain.perawallet.app/",
      port: 443
    }
  },
  testnet: {
    algodev: {
      clientToken: "0dw4Qu6ckPJTQY540Z0sEokH910KUWKjsf312fxNtTcVjw5UUhhlK4s4odcXIoEz",
      clientServer: "https://node-testnet.chain.perawallet.app/",
      indexerToken: "KegWFLYQnBNVeP4oHCX64dObBk8VemzYdNqsnAOIxYQ8aqJLQTYeVDQyZNnx1PZA",
      indexerServer: "https://indexer-testnet.chain.perawallet.app/",
      port: 443
    }
  }
};

const ALGORAND_NODE_PROVIDERS: AlgorandNodeProvider[] = [
  {type: "algodev", isHealthy: true, title: "Algodev"}
];

const ALGORAND_MIN_TX_FEE = 1000n;

export {
  ALGOD_CREDENTIALS,
  DEFAULT_ALGORAND_NODE_PROVIDER_TYPE,
  ALGORAND_NODE_PROVIDERS,
  ALGORAND_MIN_TX_FEE
};
